import { Pipe, PipeTransform } from '@angular/core';

/**
 * Telefone como se escreve: (85) 3333-4444 ou, com o nono dígito, (85) 9 9999-0000.
 *
 * O pipe `mask` do ngx-mask (9.x) não entende máscaras alternativas ("...||..."), só a
 * diretiva do input: aplicava a de fixo a um celular e cortava o último dígito.
 *
 * Uso: {{ telefone | rqPhone }}.
 */
@Pipe({ name: 'rqPhone' })
export class RqPhonePipe implements PipeTransform {
    transform(value: string | number | null | undefined): string {
        const texto = value === null || value === undefined ? '' : String(value);
        const digitos = texto.replace(/\D/g, '');

        if (digitos.length === 11) return digitos.replace(/(\d{2})(\d)(\d{4})(\d{4})/, '($1) $2 $3-$4');
        if (digitos.length === 10) return digitos.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

        return texto;
    }
}
